module.exports = __webpack_public_path__ + "img/m09.297a2436.png";